export default "__VITE_ASSET__531a973a__"